import { EntityCustomFields } from "@/shared/components/CustomFields";
import { TargetEntityType } from "@/shared/domain/customFields";
import { EventRecord } from "@/shared/domain/events";

import {
  useUpdateWorkspaceEvent,
  useWorkspaceEvent,
} from "../WorkspaceCtx/useWorkspaceEvents";

interface EventCustomFieldsProps {
  eventId: EventRecord["event_id"];
  onError: (error: Error) => void;
}

/**
 * Custom Fields section for the visualizer's event sidebar. Adapts the
 * workspace-scoped event query + update mutation to the shared
 * {@link EntityCustomFields}. Renders nothing until the event has loaded.
 */
export function EventCustomFields({
  eventId,
  onError,
}: EventCustomFieldsProps) {
  const eventQuery = useWorkspaceEvent(eventId);
  const updateEventMutation = useUpdateWorkspaceEvent();

  const event = eventQuery.data;
  if (!event) {
    return null;
  }

  return (
    <EntityCustomFields
      entityType={TargetEntityType.Event}
      orgId={event.org_id}
      values={event.custom_fields}
      commit={(changeset) =>
        updateEventMutation.mutateAsync({
          eventId,
          request: { custom_fields_changeset: changeset },
        })
      }
      onError={(err) => {
        if (err) {
          onError(err);
        }
      }}
      variant="plain"
    />
  );
}
